import moment from "jalali-moment";

export const chartDateGenerator = (From, To) => {
  function getDates(startDate, endDate) {
    const dates = [];
    let currentDate = startDate;
    const addDays = function (days) {
      const date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };
    while (currentDate <= endDate) {
      dates.push(currentDate);
      currentDate = addDays.call(currentDate, 1);
    }
    return dates;
  }
  let fri = moment.from(`${From}`, "fa", "YYYY/MM/DD").format("YYYY/MM/DD");
  let friDay = new Date(fri);
  let sat = moment.from(`${To}`, "fa", "YYYY/MM/DD").format("YYYY/MM/DD");
  let satDay = new Date(sat);
  const dateArrayFinal = [];
  const weekDayArray = [
    "یکشنبه",
    "دوشنبه ",
    "سه شنبه",
    "چهارشنبه ",
    " پنجشنبه",
    "جمعه ",
    "شنبه",
  ];
  const dates = getDates(new Date(sat), new Date(fri));
  dates.forEach(function (date) {
    let name = moment(date, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
    let now = new Date();
    let day = "";
    if (now.getDay() === date.getDay()) {
      day = "امروز";
    } else {
      day = weekDayArray[date.getDay()];
    }
    dateArrayFinal.push({ date: name, day: day });
  });

  return dateArrayFinal;
};
